import { getWishlistEntries, deleteWishlistEntry } from '../models/wishlistModel';

export const fetchWishlistData = async (setEntries, setIsLoading, setError) => {
  setIsLoading(true);
  setError('');
  
  try {
    const entries = await getWishlistEntries();
    setEntries(entries);
  } catch (error) {
    console.error('Error fetching wishlist data:', error);
    setError('Failed to load wishlist data. Please try again.');
  } finally {
    setIsLoading(false);
  }
};

export const removeWishlistEntry = async (entryId, currentEntries, setEntries, setError) => {
  try {
    const result = await deleteWishlistEntry(entryId);
    
    if (result.success) {
      // Update the entries list without a full reload
      const updatedEntries = currentEntries.filter(entry => entry.id !== entryId);
      setEntries(updatedEntries);
      return true;
    } else {
      setError(result.error || 'Failed to delete entry');
      return false;
    }
  } catch (error) {
    console.error('Error removing wishlist entry:', error);
    setError('An error occurred while deleting the entry');
    return false;
  }
}; 